import { customerBaseApi } from "@/react/services/api";
import { HttpMethods } from "@/react/http";

const DIALPLANS = Object.freeze("dialplans");

const crudCustomerBasedApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getDialplans: build.query({
      query: () => ({
        method: HttpMethods.GET,
        url: DIALPLANS,
      }),
      // Some ID is required to check for name uniqueness when creating a new Dial Plan
      // For simplicity, since name is unique already, setting an ID equal to name
      transformResponse: (response) =>
        response.map((dialplan) => ({ id: dialplan.name, ...dialplan })),
      providesTags: [DIALPLANS],
    }),
    createDialplan: build.mutation({
      query: ({ dialplan }) => ({
        method: HttpMethods.POST,
        url: DIALPLANS,
        body: dialplan,
      }),
      invalidatesTags: [DIALPLANS],
    }),
    updateDialplan: build.mutation({
      query: ({ dialplan }) => ({
        method: HttpMethods.PUT,
        url: DIALPLANS,
        body: dialplan,
      }),
      invalidatesTags: [DIALPLANS],
    }),
    deleteDialplan: build.mutation({
      query: ({ dialplanId }) => ({
        method: HttpMethods.DELETE,
        url: `${DIALPLANS}/${dialplanId}`,
      }),
      invalidatesTags: [DIALPLANS],
    }),
  }),
});

export const {
  useGetDialplansQuery,
  useLazyGetDialplansQuery,
  useCreateDialplanMutation,
  useUpdateDialplanMutation,
  useDeleteDialplanMutation,
} = crudCustomerBasedApi;
